import Imm from '../support/ImmutableHelpers';
import DataStore from '../support/DataStore';
import { PositionMap } from '../types/shared/PositionMap';

let dataStore = DataStore.getInstance('app');

type Market = {
  id: string;
  name: string;
};

export function reorderArray<T>(
  arr: Array<T>,
  oldIndex: number,
  newIndex: number,
): Array<T> {
  if (oldIndex > newIndex) {
    let el = arr[oldIndex];
    let intermediateArray = [
      ...arr.slice(0, oldIndex),
      ...arr.slice(oldIndex + 1),
    ];
    let newArray = [
      ...intermediateArray.slice(0, newIndex),
      el,
      ...intermediateArray.slice(newIndex),
    ];
    return newArray as Array<T>;
  } else if (oldIndex < newIndex) {
    let el = arr[oldIndex];
    let newArray = [
      ...arr.slice(0, newIndex + 1),
      el,
      ...arr.slice(newIndex + 1),
    ];
    newArray.splice(oldIndex, 1);
    return newArray as Array<T>;
  } else {
    return arr;
  }
}

class SpotDesignationActions {
  static updatePositionNames(market: Market, index: string, name: string) {
    let positionMapByMarket = dataStore.get('position');
    if (!positionMapByMarket) {
      return;
    }
    let marketID = market.id;
    let newPositionMap = Imm.setProperty(
      positionMapByMarket,
      marketID,
      (oldPositionMap) => {
        let object = oldPositionMap || {};
        return Imm.setProperty(object, index, name);
      },
    );
    dataStore.set('position', newPositionMap);
  }

  static updatePositionOrder(
    market: Market,
    oldIndex: string,
    newIndex: string,
  ) {
    let positionMapByMarket = dataStore.get('position');
    if (!positionMapByMarket) {
      return;
    }
    let marketID = market.id;
    let positionMap = Object.values(positionMapByMarket[marketID] || {});

    const parsedOldIndex = parseInt(oldIndex, 10);
    const parsedNewIndex = parseInt(newIndex, 10);

    positionMap = reorderArray(positionMap, parsedOldIndex, parsedNewIndex);

    let newPositionMap = { ...positionMapByMarket };

    let newObj: PositionMap = Object.fromEntries(
      positionMap.map((position, i) => [i.toString(), position]),
    );

    newPositionMap[marketID] = newObj;

    dataStore.set('position', newPositionMap);
  }

  static swapPositionOrder(market: Market, oldIndex: string, newIndex: string) {
    let positionMapByMarket = dataStore.get('position');
    if (!positionMapByMarket) {
      return;
    }
    let marketID = market.id;
    let positionMap = positionMapByMarket[marketID] || {};
    let oldIndexValue = positionMap[oldIndex];
    let newIndexValue = positionMap[newIndex];
    let newPositionMap = Imm.setProperties(positionMapByMarket, {
      [marketID]: Imm.setProperties(positionMap, {
        [oldIndex]: newIndexValue,
        [newIndex]: oldIndexValue,
      }),
    });
    dataStore.set('position', newPositionMap);
  }
}

export default SpotDesignationActions;
